export default "__VITE_ASSET__c6b91d97__"